/** Route helpers for the Help feature. The registry is generated from
 *  stories/*.md (see scripts/gen-help.mjs); ids are compile-time checked so a
 *  renamed story breaks the build instead of producing a dead link. */
import { HELP_STORIES, type HelpStoryId } from './registry.gen';

export function helpScopePath(scope: string): string {
  return `/help/${scope}`;
}

/** In-app path to one story: /help/<scope>#<story-id>. */
export function helpStoryPath(id: HelpStoryId): string {
  const ref = HELP_STORIES[id];
  return `/help/${ref.scope}#${id}`;
}

export function helpStoryTitle(id: HelpStoryId): string {
  const ref = HELP_STORIES[id];
  return `${ref.number} — ${ref.title}`;
}
